import React from 'react';
import observ from 'observ';
import struct from 'observ-struct';
import xtend from 'xtend';
import { EventEmitter } from 'events';

import ObservApi from '../lib/observable-api';
import AccountsController from '../account/AccountsController';
import AccountStore from '../account/AccountStore';
import UserStore from '../account/UserStore';
function noop () {}

function BillingStore () {
    return struct({
        data: struct({}),
        error: observ(null),
        hasFetched: observ(false)
    });
}

const Account = (api, socket, opts) => {
    var accountsBus = new EventEmitter();
    var accountApi = ObservApi(api.users);
    var accountStore = AccountStore(accountApi.bus, accountsBus);

    var usersWsBus = new EventEmitter();
    var userApi = ObservApi(api.users);
    var userStore = UserStore(userApi.bus, usersWsBus);

    var state = window.accountState = struct({
        user: userStore.state,
        billing: BillingStore(),
        billingLM: BillingStore(),
        accounts: accountStore.state,
        resetTokens: struct({
            haveReset: struct({}),
            isResolving: observ(false)
        }),
        keys: struct({
            isResolving: observ(false),
            data: observ(false),
            error: observ(null),
            requiresCreate: observ(false)
        })
    });

    var actions = xtend({
        getUser: function () {
            userApi.actions.get({ userID: opts.credentials.user.userId });
        },

        getBilling: function (data) {
            api.analytics.getBillingUsageMTD(data || {}, function (err, body) {
                if (err) return state.billing.error.set(err);
                state.billing.data.set(body.result[0]);
                state.billing.hasFetched.set(true);
            })
        },

        // get billing last month
        getBillingLM: function (data) {
            if (state.billingLM().hasFetched) return;
            api.analytics.getBillingUsageLM(data || {}, function (err, body) {
                if (err) return state.billimgLM.error.set(err);
                state.billingLM.data.set(body.result[0]);
                state.billingLM.hasFetched.set(true);
            });
        },

        editSelf: function (user) {
            userApi.actions.edit(xtend(user, {
                userID: opts.credentials.user.userId
            }));
        },

        getAccounts: function () {
            accountApi.actions.get({});
        },

        edit: accountApi.actions.edit,
        add: accountApi.actions.add,
        'delete': accountApi.actions.delete,

        createApiKey: function () {
            state.keys.set(xtend(state.keys(), {
                isResolving: true,
                data: false
            }));

            api.keys.create(function (err, resp) {
                if (err) {
                    state.keys.set(xtend(state.keys(), {
                        isResolving: false,
                        error: err
                    }));
                    return console.warn(err);
                }

                state.keys.set(xtend(state.keys(), {
                    isResolving: false,
                    data: resp.data.APIkey,
                    error: null
                }));
            });
        },

        shiftKeyError: function () {
            state.keys.error.set(null);
        },

        resetPassword: function (user, cb) {
            cb = cb || noop;
            state.resetTokens.isResolving.set(true);

            api.accounts.requestNewResetToken(user, function (err, resp) {
                if (err) {
                    state.resetTokens.isResolving.set(false);
                    return cb(err);
                }

                var newData = {};
                newData[user.userId] = true;
                state.resetTokens.set({
                    isResolving: false,
                    haveReset: xtend(state.resetTokens.haveReset(), newData)
                });

                cb(err, resp);
            });
        },

        getApiKey: function () {
            state.keys.set(xtend(state.keys(), {
                isResolving: true,
                data: false,
                error: state.keys.error()
            }));

            api.keys.get(function (err, resp) {
                if (err) {
                    return state.keys.set(xtend(state.keys(), {
                        isResolving: null,
                        error: err
                    }));
                }

                if (resp && resp.data) {
                    state.keys.set(xtend(state.keys(), {
                        isResolving: false,
                        data: resp.data.APIkey,
                        error: null
                    }));
                } else {
                    // XXX Client most likely doesn't have one set
                    state.keys.set(xtend(state.keys(), {
                        isResolving: false,
                        data: false,
                        requiresCreate: true
                    }));
                }
            });
        },

        unlock: function () {
            // @TODO
        }
    });

    return props => {
        return <AccountsController
            {...props}
            getUsers={api.users.get}
            credentials={opts.credentials}
            store={state}
            actions={actions}
            onError={userApi.bus.on.bind(userApi.bus, 'error')}
        />
    }

};

export default Account
